export default __webpack_public_path__ + "static/media/icon-sms.f9ad907f.svg";